module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAAAXNSR0IArs4c6QAAAR1JREFUWEftWMENwjAMPG/AA2bkyxAswn5IsIERlYKQqWvXpIkC7rNxncvlYl9KGOyhwfAiAW+9Y8lwN4aZ+QjgDGDvBHEHcCKiy3t8rTwlpyoJZr4B2DnBlrArER0E4Cp5PID5GURELp0z82y89l4jwopfYnhswGXlkpmyA16Go3lWSyI6kVxINE8CTkko1cldJaLa66Zhq4F4JRHNs/rQRSeyGoHMa8X/VGsey/xYEug17jI2vcDNzZuAt96NpSpR69BNNvVVR5UOJhuT5sNblLVmgKsa+BYMjw34W/NjHUbv3bGZW0vAlmtKSQiGUsPWobFuHNb32v+Oj/fRX0aW5su4pn1rAX/RmscyP9aW9RpPA78188lwMiwYeAC8Oco8nrRtfgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/share/home/qrCode.png
// module id = K2sG
// module chunks = 0